<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div
    class="chatmigo-detail-card overflow-auto"
    :class="
      compact
        ? 'rounded-xl border border-n-weak/80 bg-n-surface-1 px-3 py-2.5'
        : 'rounded-2xl border border-n-weak/80 bg-n-surface-1 px-4 py-3'
    "
  >
    <div class="mb-1.5 flex items-center justify-between gap-2">
      <span class="text-sm font-medium text-n-slate-12">
        {{ title }}
      </span>
      <slot name="button" />
    </div>
    <div v-if="value" class="break-words text-sm leading-6 text-n-slate-11">
      <slot>
        {{ value }}
      </slot>
    </div>
  </div>
</template>
